import { render, staticRenderFns } from "./RewardsComponent.vue?vue&type=template&id=180a2747&"
import script from "./RewardsComponent.vue?vue&type=script&lang=js&"
export * from "./RewardsComponent.vue?vue&type=script&lang=js&"
import style0 from "./RewardsComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports